export default {
  "walletChangeList.title": "Wallet Change Records",
  "walletChangeList.action.details": "Details",
  "walletChangeList.copy.success": "Copied to clipboard",
  "walletChangeList.tooltip.copy.userNo": "Copy UserNo: {text}",
  "walletChangeList.tooltip.copy.recordNo": "Copy RecordNo: {text}",
  "walletChangeList.tooltip.copy.sourceId": "Copy SourceId: {text}",
  "walletChangeList.tooltip.showUserDetails": "Show User Details",
  "walletChangeList.modal.title.details": "Details",
  "walletChangeList.modal.title.userDetails": "User Details",
  "walletChangeList.column.no": "#NO",
  "walletChangeList.column.recordNo": "RecordNo",
  "walletChangeList.column.userNo": "UserNo",
  "walletChangeList.column.sourceId": "SourceId",
  "walletChangeList.column.beforeBalance": "Before Balance",
  "walletChangeList.column.amount": "Amount",
  "walletChangeList.column.afterBalance": "After Balance",
  "walletChangeList.column.beforeBonus": "Before Bonus",
  "walletChangeList.column.bonusAmount": "Bonus Amount",
  "walletChangeList.column.afterBonus": "After Bonus",
  "walletChangeList.column.beforeBonusAmount": "Before Bonus Amount",
  "walletChangeList.column.afterBonusAmount": "After Bonus Amount",
  "walletChangeList.column.beforeBonusWager": "Before Bonus Wager",
  "walletChangeList.column.afterBonusWager": "After Bonus Wager",
  "walletChangeList.column.beforeWithdrawLimit": "Before Withdraw Limit",
  "walletChangeList.column.afterWithdrawLimit": "After Withdraw Limit",
  "walletChangeList.column.sourceType": "Source Type",
  "walletChangeList.column.sourceDetail": "Source Detail",
  "walletChangeList.column.remark": "Remark",
  "walletChangeList.column.operator": "Operator",
  "walletChangeList.column.createTime": "Create Time",
  "walletChangeList.column.action": "Action",
  "walletChangeList.search.recordNo": "RecordNo",
  "walletChangeList.search.userNo": "UserNo",
  "walletChangeList.search.sourceType": "Source Type",
  "walletChangeList.search.createTime": "Create Time",
};
